import React from "react";

interface PromoIconCardsProps {
  icon1Url?: string;
  icon2Url?: string;
}

const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>): void => {
  const target = e.target as HTMLImageElement;
  target.style.display = "none";
  const fallback = target.nextElementSibling as HTMLElement;
  if (fallback) fallback.style.display = "block";
};

const PromoIconCards: React.FC<PromoIconCardsProps> = ({ icon1Url, icon2Url }) => (
  <div className="flex items-center justify-center gap-6 mb-8">
    {/* Icon 1 */}
    <div className="relative w-24 h-24 bg-[#f5e6d3] rounded-2xl border border-border flex items-center justify-center shadow-sm">
      {icon1Url ? <img src={icon1Url} alt="" className="w-16 h-16 object-contain" onError={handleImageError} /> : null}
      <svg className={`w-16 h-16 text-[#d4a574] ${icon1Url ? "hidden" : ""}`} fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
      </svg>
    </div>

    {/* Icon 2 */}
    <div className="relative w-28 h-28 bg-[#f5e6d3] rounded-2xl border border-border flex items-center justify-center shadow-sm">
      {icon2Url ? <img src={icon2Url} alt="" className="w-20 h-20 object-contain" onError={handleImageError} /> : null}
      <svg className={`w-20 h-20 ${icon2Url ? "hidden" : ""}`} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="20" y="40" width="60" height="50" fill="#d4a574" />
        <rect x="20" y="40" width="60" height="15" fill="#c89664" />
        <rect x="45" y="25" width="10" height="30" fill="#e67e22" />
        <path d="M35 25 L50 40 L50 25 L65 25 L50 40 L50 55 L35 55 Z" fill="#e67e22" />
        <path d="M65 25 L50 40 L50 25 L50 40 L50 55 L65 55 Z" fill="#d35400" />
        <circle cx="40" cy="30" r="8" fill="#e67e22" />
        <circle cx="60" cy="30" r="8" fill="#e67e22" />
        <circle cx="40" cy="30" r="4" fill="#fff" opacity="0.3" />
        <circle cx="60" cy="30" r="4" fill="#fff" opacity="0.3" />
      </svg>
    </div>
  </div>
);

export default PromoIconCards;
